import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "popover_wrapper" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "popover_header" }
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { class: "close pointer" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 2,
  class: "slot-content"
}
const _hoisted_8 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Loader = _resolveComponent("Loader")
  const _component_el_popover = _resolveComponent("el-popover")
  const _directive_click_outside = _resolveDirective("click-outside")

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_popover, {
      ref: "pp",
      placement: "top-end",
      "popper-class": "popover_container",
      width: "max-content",
      visible: $data.visible,
      "popper-options": $data.options
    }, {
      reference: _withCtx(() => [
        _createElementVNode("div", {
          ref: "toggle",
          class: "popover_toggle pointer",
          disabled: $options.disabled,
          onClick: _cache[0] || (_cache[0] = (...args) => ($options.show && $options.show(...args)))
        }, [
          _createVNode(_component_Icon, {
            external: "",
            icon: "stars-02-brand",
            width: "2rem",
            height: "2rem",
            stroke: "var(--brand-600)",
            "stroke-width": "2"
          })
        ], 8 /* PROPS */, _hoisted_2)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Icon, {
              icon: "stars-02",
              width: "2rem",
              height: "2rem",
              stroke: "var(--brand-600)",
              "stroke-width": "2"
            }),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "title" }, "AI content suggestion", -1 /* HOISTED */))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Icon, {
              icon: "x",
              width: "2rem",
              height: "2rem",
              stroke: "var(--gray-500)",
              onClick: _cache[1] || (_cache[1] = $event => ($options.hide($event)))
            })
          ])
        ]),
        _createElementVNode("div", {
          class: "popover_content",
          style: _normalizeStyle({'margin-bottom': $props.content_margin})
        }, [
          ($data.task_error)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "error",
                innerHTML: $options.errmsg
              }, null, 8 /* PROPS */, _hoisted_6))
            : ($options.loading)
              ? (_openBlock(), _createBlock(_component_Loader, {
                  key: 1,
                  inline: "",
                  large: ""
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ]))
        ], 4 /* STYLE */),
        _createElementVNode("div", {
          class: "popover_controls",
          disabled: $options.loading
        }, [
          _renderSlot(_ctx.$slots, "controls", {}, undefined, true)
        ], 8 /* PROPS */, _hoisted_8)
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["visible", "popper-options"])
  ])), [
    [_directive_click_outside, $options.onClickOutside]
  ])
}